// @flow

import qs from 'qs';
import paramsList from 'constants/paramsList';

export default (query: {}) => {
  const updatedQuery = {};

  Object.keys(query).forEach(key => {
    if (query[key]) updatedQuery[paramsList[key].name] = query[key];
  });

  return qs.stringify(updatedQuery, { indices: false });
};
